// G.2 — Trip-link API hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useFreightLinks = (rid) =>
  useQuery({
    queryKey: ["freight-links", rid],
    queryFn: () => axios.get(`${API}/freight-links`, { params: { request_id: rid } }).then((r) => r.data),
    enabled: !!rid,
  });

export const useCreateFreightLink = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => axios.post(`${API}/freight-links`, body).then((r) => r.data),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ["freight-links", vars.from_request_id] });
      qc.invalidateQueries({ queryKey: ["freight-links", vars.to_request_id] });
    },
  });
};

export const useDeleteFreightLink = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (link_id) => axios.delete(`${API}/freight-links/${link_id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["freight-links"] }),
  });
};
